const svgData = `<div class="viewBox viewBox-01">
<div class="vector-group vector-group-01">
    {{-- <div class="vector"></div> --}}
    <svg xmlns="http://www.w3.org/2000/svg" width="1039.105" height="734.218">
        <defs>
            <linearGradient id="fadeGrad" y2="1" x2="0">
                <stop offset="0.5" stop-color="white" stop-opacity="0" />
                <stop offset="1" stop-color="white" stop-opacity=".5" />
            </linearGradient>
            <linearGradient id="linear-gradient" x1="1" y1="0.5" x2="0" y2="0.5"
                gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#545fa5" />
                <stop offset="0.562" stop-color="#fff" stop-opacity="0.18" />
                <stop offset="1" stop-color="#fff" stop-opacity="0" />
            </linearGradient>

            <mask id="fade" maskContentUnits="objectBoundingBox">
                <rect width="1" height="1" fill="url(#fadeGrad)" />
            </mask>
        </defs>
        <path id="Path_2" data-name="Path 2"
            d="M.049 726.717s831.551-5.446 862.475-5.446 163.851-47.714 167.469-156.652 0-564.56 0-564.56"
            fill="none" stroke="#3490dc" stroke-width="15" />

        <rect id="Rectangle_993" data-name="Rectangle 993" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="5s" repeatCount="indefinite" rotate="auto" calcMode="linear">
                <mpath xlink:href="#Path_2"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>
<div class="viewBox viewBox-02">
<div class="vector-group vector-group-02">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1039.105 734.218" width="1039.105" height="734.218">
        <path id="Path_2" data-name="Path 2"
            d="M.049 726.717s831.551-5.446 862.475-5.446 163.851-47.714 167.469-156.652 0-564.56 0-564.56"
            fill="none" stroke="#3490dc" stroke-width="15" />
        <rect id="Rectangle_994" data-name="Rectangle 994" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="3.5s" repeatCount="indefinite" rotate="auto" keyPoints="1;0" keyTimes="0;1"
                calcMode="linear">
                <mpath xlink:href="#Path_2"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>
<div class="viewBox  viewBox-03">
<div class="vector-group vector-group-03">
    <svg xmlns="http://www.w3.org/2000/svg" width="1225.065" height="879.015">
        <path id="Path_3" data-name="Path 3"
            d="M0 7.5h985.684c47.314 0 155.157 65.582 169.27 223.969s62.648 646.812 62.648 646.812" fill="none"
            stroke="#3490dc" stroke-width="15" />
        <rect id="Rectangle_994" data-name="Rectangle 994" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="6s" repeatCount="indefinite" rotate="auto" keyPoints="0;1" keyTimes="0;1"
                calcMode="linear">
                <mpath xlink:href="#Path_3"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>
<div class="viewBox  viewBox-04">
<div class="vector-group vector-group-04">
    <svg xmlns="http://www.w3.org/2000/svg" width="1225.065" height="879.015">
        <path id="Path_3" data-name="Path 3"
            d="M0 7.5h985.684c47.314 0 155.157 65.582 169.27 223.969s62.648 646.812 62.648 646.812" fill="none"
            stroke="#3490dc" stroke-width="15" />
        <rect id="Rectangle_994" data-name="Rectangle 994" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="4.5s" repeatCount="indefinite" rotate="auto" keyPoints="1;0" keyTimes="0;1"
                calcMode="linear">
                <mpath xlink:href="#Path_3"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>

<div class="viewBox  viewBox-05">
<div class="vector-group vector-group-05">
    <svg xmlns="http://www.w3.org/2000/svg" width="1039.105" height="734.218">
        <path id="Path_2" data-name="Path 2"
            d="M.049 726.717s831.551-5.446 862.475-5.446 163.851-47.714 167.469-156.652 0-564.56 0-564.56"
            fill="none" stroke="#3490dc" stroke-width="15" />
        <rect id="Rectangle_994" data-name="Rectangle 994" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="5.5s" repeatCount="indefinite" rotate="auto" keyPoints="0;1" keyTimes="0;1"
                calcMode="linear">
                <mpath xlink:href="#Path_2"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>
<div class="viewBox  viewBox-06">
<div class="vector-group vector-group-06">
    <svg xmlns="http://www.w3.org/2000/svg" width="471" height="176.03">
        <path id="Path_28" data-name="Path 28"
            d="M6 0v52.784C6 90.9 50.269 172.839 172.82 169.956s298.081 0 298.081 0" fill="none"
            stroke="#3490dc" stroke-width="12" opacity=".504" />
        <rect id="Rectangle_994" data-name="Rectangle 994" width="23" height="12" rx="5" opacity="0.6"
            fill="url(#linear-gradient)" transform="translate(-11,-7)">
            <animateMotion dur="4.5s" repeatCount="indefinite" rotate="auto" keyPoints="0;1" keyTimes="0;1"
                calcMode="linear">
                <mpath xlink:href="#Path_28"></mpath>
            </animateMotion>
        </rect>
    </svg>
</div>
</div>`;

const backgroundAnimation = () => {
    $(".background-animation").html(svgData);
}

module.exports = backgroundAnimation